import { useRegisterSW } from "virtual:pwa-register/react";

export default function UpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div className="fixed bottom-20 left-1/2 z-50 w-[calc(100%-2rem)] max-w-sm -translate-x-1/2 rounded-xl border border-primary/30 bg-slate-900 px-4 py-3 shadow-lg">
      <p className="text-[13px] text-slate-200">Nueva versión disponible</p>
      <div className="mt-2 flex gap-2">
        <button
          type="button"
          onClick={() => updateServiceWorker(true)}
          className="rounded-lg bg-primary px-4 py-1.5 text-[13px] font-semibold text-white transition hover:bg-primary-dark"
        >
          Actualizar
        </button>
      </div>
    </div>
  );
}
